import PropTypes from 'prop-types';

import Link from 'core/components/Link';
import { resolveScopedStyles } from 'core/utils/styled-jsx';

import styles from './index.styl';

export default function InfoBlock(props) {
  const {
    caption,
    to,
    children,
    parentProps,
  } = props;

  const {
    theme: {
      animations: {
        hover: hoverAnimation,
      },
      controls: {
        smartTeaser: {
          carRelease: carReleaseAtoms,
        },
      },
      colors,
    },
  } = parentProps;

  const scoped = resolveScopedStyles(
    <scope>
      <style jsx>{`
        .infoLink
          color ${carReleaseAtoms.link.color}
          border-bottom ${carReleaseAtoms.link.borderBottom}
          transition border-color ${hoverAnimation}
          text-decoration ${carReleaseAtoms.link.textDecoration}
          &:visited
          &:active
            color ${carReleaseAtoms.link.color}
            text-decoration none
          &:hover
            text-decoration ${carReleaseAtoms.link.textDecoration}
            border-bottom ${carReleaseAtoms.link.hover.borderBottom}
            color ${carReleaseAtoms.link.hover.color}
      `}</style>
    </scope>
  );
  return (
    <div className={styles.infoBlock}>
      <style jsx>{`
        .${styles.infoBlock}
          :global(.mobile) &
            border-right 1px solid ${colors.divider}
            &:last-child
              border-right none
        .${styles.caption}
          font ${carReleaseAtoms.caption.font}
          color ${carReleaseAtoms.caption.color}
        .${styles.blockContent}
          font ${carReleaseAtoms.info.font}
      `}</style>
      <div className={styles.caption}>
        {caption}
      </div>
      <div className={styles.blockContent}>
        <Link
          to={to}
          className={scoped.wrapClassNames('infoLink')}
          followExternal
        >
          {children}
        </Link>
      </div>
      <scoped.styles />
    </div>
  );
}

InfoBlock.propTypes = {
  caption: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  parentProps: PropTypes.object,
};
